<app-home-count-box
        [title]="'HOME.COUNT_BOX.UNREAD' | translate"
        [number]="unreadMessages"
        [subtitle]="'HOME.COUNT_BOX.TOTAL' | translate: {total: totalMessages}"
        icon="fa fa-envelope"
></app-home-count-box>
